import { colors } from '@chegg-ui/theme'
import { FunctionComponent, useEffect, useState } from 'react'
import { INFOTOOLTIP_TEST_ID } from '@chegg-wt/core-wa/constants/paraphraser'
import { AIStarIcon } from '../icons/AIStarIcon'
import { InfoTooltipContainer } from './styled'
import { InfoTooltipProps } from './types'
import { MESSAGE_DURATION_SECONDS, MESSAGE } from './constants'

export const InfoTooltip: FunctionComponent<InfoTooltipProps> = ({
  name,
  top,
  right,
  left,
  isFixed,
  autoDisappear = true,
}) => {
  const [show, setShow] = useState(true)
  useEffect(() => {
    if (!autoDisappear) return
    const setTimeoutId = setTimeout(() => {
      setShow(false)
    }, MESSAGE_DURATION_SECONDS)

    return () => {
      clearTimeout(setTimeoutId)
    }
  }, [autoDisappear])

  if (!show) return null

  return (
    <InfoTooltipContainer
      top={top}
      right={right}
      left={left}
      autoDisappear={autoDisappear}
      isFixed={isFixed}
      data-test={`${INFOTOOLTIP_TEST_ID}-${name}`}
    >
      <AIStarIcon color={colors.white} size="x-small" />
      <span>{MESSAGE[name]}</span>
    </InfoTooltipContainer>
  )
}
